


export default function load() {
    this.dataSet("conf/load",true);
  }
